/* eslint-disable import/prefer-default-export */

export function mapKeys(obj, fn) {
  if (obj == null) {
    return obj
  }

  return Object.keys(obj).reduce((acc, key) => {
    const newKey = fn(key)

    acc[newKey] = obj[key]

    return acc
  }, {})
}
